import Vue from "vue";
import { Auth } from "@/_nav";

type RBAC = {
    auth: Auth;
};

type PermissionMap = Record<string, boolean>;

type AuthMixinThis = Vue & {
    auth?: Auth;
    $toasted: { error: (msg: string) => void };
    mixin_permissions: PermissionMap;
    showError: () => void;
    redirect: () => void;
};

const isValidArray = (value: unknown): value is string[] =>
    Array.isArray(value) && value.length > 0;

const isValidAuth = (val: unknown): val is RBAC => {
    const candidate = val as RBAC;
    return (
        !!candidate &&
        !!candidate.auth &&
        (isValidArray(candidate.auth.required) || isValidArray(candidate.auth.oneOf))
    );
};

export const authMixin = Vue.extend({
    created(this: AuthMixinThis) {
        if (!isValidAuth(this)) {
            console.error("Invalid auth parameter");
            return;
        }

        const { required, oneOf } = this.auth;
        const permissions = this.mixin_permissions;

        if (isValidArray(required)) {
            for (let i = 0; i < required.length; i++) {
                const perm = required[i];
                if (!permissions[perm]) {
                    this.showError();
                    this.redirect();
                }
            }
        }

        if (isValidArray(oneOf)) {
            const found = oneOf.find((p) => permissions[p]);
            if (!found) {
                this.showError();
                this.redirect();
            }
        }
    },

    methods: {
        showError(this: AuthMixinThis) {
            this.$toasted.error("Unauthorized access");
        },
        redirect(this: AuthMixinThis) {
            this.$router.push("/dashboard");
        },
    },

    computed: {
        mixin_permissions(this: AuthMixinThis): PermissionMap {
            return this.$store?.state?.auth?.permissions || {};
        },
    },
});
